import UpdateItemReceive from "../../../../components/@documents/item_receives/UpdateItemReceive";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemReceiveUpdatePage() {

    return (
        <UpdateItemReceive 
            routeType={routeTypes.workstation}
        />
    )
}